/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BytesLike,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { GOHMMagician, GOHMMagicianInterface } from "../GOHMMagician";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_quote",
        type: "address",
      },
      {
        internalType: "contract IOlympusStakingV3Like",
        name: "_olympusStakingV3",
        type: "address",
      },
      {
        internalType: "contract IBalancerVaultLike",
        name: "_balancerVault",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "_balancerOhmPool",
        type: "bytes32",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "InvalidAsset",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidBalancerPool",
    type: "error",
  },
  {
    inputs: [],
    name: "BALANCER_OHM_POOL",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "BALANCER_VAULT",
    outputs: [
      {
        internalType: "contract IBalancerVaultLike",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "GOHM",
    outputs: [
      {
        internalType: "contract IGOHMLikeV2",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OHM",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OLYMPUS_STAKING_CLAIM",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OLYMPUS_STAKING_REBASING",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OLYMPUS_STAKING_TRIGGER",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OLYMPUS_STAKING_V3",
    outputs: [
      {
        internalType: "contract IOlympusStakingV3Like",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "QUOTE",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SWAP_AMOUNT_IN_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SWAP_AMOUNT_OUT_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TEN_POW_GOHM_DECIMALS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TWO_EXTRA_WEIS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_gOhmAmount",
        type: "uint256",
      },
    ],
    name: "ohmBalanceFrom",
    outputs: [
      {
        internalType: "uint256",
        name: "ohmAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "towardsAsset",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "towardsNative",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IBalancerVaultLike",
        name: "_balancerVault",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "_poolId",
        type: "bytes32",
      },
    ],
    name: "verifyPoolAndVault",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type GOHMMagicianConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GOHMMagicianConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class GOHMMagician__factory extends ContractFactory {
  constructor(...args: GOHMMagicianConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "GOHMMagician";
  }

  deploy(
    _quote: string,
    _olympusStakingV3: string,
    _balancerVault: string,
    _balancerOhmPool: BytesLike,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<GOHMMagician> {
    return super.deploy(
      _quote,
      _olympusStakingV3,
      _balancerVault,
      _balancerOhmPool,
      overrides || {}
    ) as Promise<GOHMMagician>;
  }
  getDeployTransaction(
    _quote: string,
    _olympusStakingV3: string,
    _balancerVault: string,
    _balancerOhmPool: BytesLike,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _quote,
      _olympusStakingV3,
      _balancerVault,
      _balancerOhmPool,
      overrides || {}
    );
  }
  attach(address: string): GOHMMagician {
    return super.attach(address) as GOHMMagician;
  }
  connect(signer: Signer): GOHMMagician__factory {
    return super.connect(signer) as GOHMMagician__factory;
  }
  static readonly contractName: "GOHMMagician";
  public readonly contractName: "GOHMMagician";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GOHMMagicianInterface {
    return new utils.Interface(_abi) as GOHMMagicianInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GOHMMagician {
    return new Contract(address, _abi, signerOrProvider) as GOHMMagician;
  }
}
